import React, { useEffect, useState } from "react";
import Switch from "../Form/Switch";
import { Col, Row } from "react-bootstrap";
import CustomTooltip from "../Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Select from "../Select";
import LightboxSearchSelect from "./LightboxSearchSelect";
import { getTranslation } from "../../../hooks/utils";
import { element } from "prop-types";
import CommonModal from "../../Modals/CommonModal";
import LightboxContent from "../../Pages/Kdf/EditKdf/elementModal/elementSections/lightBoxSection/LightboxContent";
import Input from "../Input";
const PopupOptionsTab = ({
  editLaserLinkItem,
  updateEditLaserLinkItem,
  popupOptions,
  validationTrigger,
  errorListData,
  updateErrorStatus,
  getDocFiles
}) => {
  const [showLightBox, setShowLightBox] = useState(null);
  const renderOption = (data) => {
    return Object.keys(data)?.map((item, index) => (
      <option key={index} value={data[item]}>
        {data[item]}
      </option>
    ));
  };

  // Private KDFs are hidden from other users, but the KDF's own owner can
  // still use its lightboxes (current_user_doc comes from the backend).
  const isLightboxSelectable = (o) => o?.doc_private === false || o?.current_user_doc === true;

  // This KDF's lightboxes first, then the rest; each group alphabetical by name.
  const sortLightboxes = (list) => {
    const docId = String(editLaserLinkItem?.doc_id ?? "");
    const byName = (a, b) =>
      (a?.name ?? "").localeCompare(b?.name ?? "", undefined, { sensitivity: "base", numeric: true });
    const own = list.filter((o) => String(o?.doc_id) === docId).sort(byName);
    const rest = list.filter((o) => String(o?.doc_id) !== docId).sort(byName);
    return [...own, ...rest];
  };

  const lightboxOptions = (options, filter = isLightboxSelectable) =>
    sortLightboxes(Object.values(options || {}).filter(filter));

  // const validateInnerData = () => {
  //   let errorToUpdate = JSON.parse(JSON.stringify(errorListData));
  //   updateErrorStatus([...errorToUpdate]);
  // }
  const validateInnerData = () => {
  const errs = [];

  // helpers
  const publicEnter = Object.values(popupOptions?.enter_pop || {}).filter(isLightboxSelectable);
  const publicExit  = Object.values(popupOptions?.exit_pop  || {}).filter(isLightboxSelectable);
  const publicTimed = Object.values(popupOptions?.timed_pop || {}).filter(o => {
    const okPages = (getDocFiles?.[0]?.num_pages || 0) >= (o?.show_after || 0);
    return isLightboxSelectable(o) && okPages;
  });

  // ENTER POP
  if (editLaserLinkItem?.enter_pop === true) {
    if (publicEnter.length === 0) errs.push("enter_no_lightbox");
    if (!editLaserLinkItem?.enter_pop_settings?.lightbox) errs.push("enter_lightbox");
    if (!editLaserLinkItem?.enter_pop_settings?.display_enter_device) errs.push("enter_device");
    if (!editLaserLinkItem?.enter_pop_settings?.frequency) errs.push("enter_frequency");
  }

  // TIMED POP
  if (editLaserLinkItem?.flash_pop === true) {
    if (publicTimed.length === 0) errs.push("timed_no_lightbox");
    if (!editLaserLinkItem?.flash_pop_settings?.lightbox) errs.push("timed_lightbox");
    if (!editLaserLinkItem?.flash_pop_settings?.display_flash_device) errs.push("timed_device");
    if (!editLaserLinkItem?.flash_pop_settings?.frequency) errs.push("timed_frequency");
  }

  // EXIT POP
  if (editLaserLinkItem?.exit_pop === true) {
    if (publicExit.length === 0) errs.push("exit_no_lightbox");
    if (!editLaserLinkItem?.exit_pop_settings?.lightbox) errs.push("exit_lightbox");
    if (!editLaserLinkItem?.exit_pop_settings?.display_device) errs.push("exit_device");
    if (!editLaserLinkItem?.exit_pop_settings?.display_scroll) errs.push("exit_scroll");
  }

  updateErrorStatus(errs);
};

const enterEmpty = Object.values(popupOptions?.enter_pop || {}).filter(isLightboxSelectable).length === 0;

const timedEmpty = Object.values(popupOptions?.timed_pop || {}).filter(o => {
  const okPages = (getDocFiles?.[0]?.num_pages || 0) >= (o?.show_after || 0);
  return isLightboxSelectable(o) && okPages;
}).length === 0;

const exitEmpty = Object.values(popupOptions?.exit_pop || {}).filter(isLightboxSelectable).length === 0;


  // Validate live (not only on Save) so the tab warning icon and disabled Save reflect errors as the user edits.
  useEffect(() => {
    validateInnerData();
  }, [validationTrigger, editLaserLinkItem, popupOptions, getDocFiles]);

  return (
    <>
      {/* editLaserLinkItem?.enter_pop_settings */}
      <CommonModal
        modalStatus={showLightBox != null}
        changeActiveStatus={(status) => setShowLightBox(null)}
        centered
        lightBox={true}
      >
        {!!showLightBox ? <LightboxContent lightbox={showLightBox} /> : ""}
      </CommonModal>

      <div className="Enable-select">
        <Row className="enable-first">
          <>
            <Switch
              type="checkbox"
              checked={editLaserLinkItem?.enter_pop ?? false}
              onChange={(element) => {
                updateEditLaserLinkItem({
                  ...editLaserLinkItem,
                  enter_pop: !!!editLaserLinkItem?.enter_pop,
                });
              }}
              formLabel={"Enable EnterPop"}
            />
          </>
          <>
            {editLaserLinkItem?.enter_pop == true ? (
              <Col md={12} className="popup-option-coloum">
                {(() => {
                  const publicEnter = Object.values(popupOptions?.enter_pop || {}).filter(isLightboxSelectable);
                  if (publicEnter.length === 0) {
                    return (
                      <div className="alert alert-warning my-2">
                        You don't have any EnterPop lightboxes yet. Open the editor and create a lightbox first.
                        {editLaserLinkItem?.doc_id && (
                          <> <a className="ms-1" target="_blank" href={`/editor/${editLaserLinkItem?.doc_id}`}>Open Editor</a></>
                        )}
                      </div>
                    );
                  }
                  return null;
                })()}
                <Switch
                  type="checkbox"
                  checked={editLaserLinkItem?.default_enter_pop ?? false}
                  onChange={(element) => {
                    updateEditLaserLinkItem({
                      ...editLaserLinkItem,
                      default_enter_pop:
                        !!!editLaserLinkItem?.default_enter_pop,
                    });
                  }}
                  formLabel={
                    <CustomTooltip
                      title={<p className="p-1 text-light">Save settings for new LaserLINX for this KDF</p>}
                    >
                      <span>Set as default</span>
                    </CustomTooltip>
                  }
                />
                {/* <div className="d-flex align-items-center for-space"> */}
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_enter_device_Device">
                      On entry {' '}
                      {!!editLaserLinkItem?.enter_pop_settings?.lightbox && (
                        <CustomTooltip title={<p className="p-1 text-light">Preview</p>}>
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                                const popupOptionsById = Object.values(popupOptions.enter_pop).reduce((acc, item) => {
                                    acc[`${item.id}`] = item;
                                    return acc;
                                }, {});
                              if (popupOptions?.enter_pop != undefined) {
                                setShowLightBox(
                                    popupOptionsById[
                                    editLaserLinkItem?.enter_pop_settings
                                      ?.lightbox
                                  ]
                                )
                              }
                            }
                            }
                            className="cursor-pointer"
                          />
                        </CustomTooltip>
                      )}
                    </label>
                  </Col>
                  <Col md={8}>
                    <LightboxSearchSelect
                      name="enter_pop_lightbox"
                      value={editLaserLinkItem?.enter_pop_settings?.lightbox ?? ""}
                      placeholder={"Select an EnterPop Lightbox"}
                      disabled={enterEmpty}
                      hasError={
                        editLaserLinkItem?.enter_pop === true &&
                        !editLaserLinkItem?.enter_pop_settings?.lightbox
                      }
                      onChange={(element) =>{
                          const popupOptionsById = Object.values(popupOptions.enter_pop).reduce((acc, item) => {
                              acc[`${item.id}`] = item;
                              return acc;
                          }, {});
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          enter_pop_settings: {
                            ...editLaserLinkItem?.enter_pop_settings,
                            lightbox: element.target.value,
                            lightbox_name:
                            popupOptionsById[`${element.target.value}`]
                                .name,
                          },
                        })
                      }}
                      options={lightboxOptions(popupOptions?.enter_pop)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_enter_device_Device">Device</label>
                  </Col>
                  <Col md={8}>
                    <Select
                      classList="mb-2"
                     name="enter_pop_device"
                    required={editLaserLinkItem?.enter_pop === true}
                    defaultValue={editLaserLinkItem?.enter_pop_settings?.display_enter_device ?? ""}
                    disabled={enterEmpty}
                    errorMessageStatus={
                      editLaserLinkItem?.enter_pop === true &&
                      !editLaserLinkItem?.enter_pop_settings?.display_enter_device
                    }
                      id="display_enter_device_Device"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          enter_pop_settings: {
                            ...editLaserLinkItem?.enter_pop_settings,
                            display_enter_device: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.display_device_settings")
                      )}
                    </Select>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="pop_setting_frequency">Frequency</label>
                  </Col>
                  <Col md={8}>
                    <Select
                      name="enter_pop_frequency"
                      required={editLaserLinkItem?.enter_pop === true}
                      defaultValue={editLaserLinkItem?.enter_pop_settings?.frequency ?? ""}
                      disabled={enterEmpty}
                      errorMessageStatus={
                        editLaserLinkItem?.enter_pop === true &&
                        !editLaserLinkItem?.enter_pop_settings?.frequency
                      }
                      id="pop_setting_frequency"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          enter_pop_settings: {
                            ...editLaserLinkItem?.enter_pop_settings,
                            frequency: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.enter_frequency_settings")
                      )}
                    </Select>
                  </Col>
                </Row>
                {/* </div> */}
              </Col>
            ) : (
              <p>
                Your selected EnterPop will appear immediately after a recipient
                clicks this LaserLINK and before the privacy notice consent
                request is displayed.
              </p>
            )}
          </>
        </Row>
      </div>

      <div className="Enable-select">
        <Row className="enable-first">
          <>
            <Switch
              type="checkbox"
              checked={editLaserLinkItem?.flash_pop ?? false}
              onChange={(element) => {
                updateEditLaserLinkItem({
                  ...editLaserLinkItem,
                  flash_pop: !!!editLaserLinkItem?.flash_pop,
                });
              }}
              formLabel={"Enable TimedPop"}
            />
          </>
          <>
            {editLaserLinkItem?.flash_pop == true ? (
              <Col md={12} className="popup-option-coloum">
                {(() => {
                  const publicTimed = Object.values(popupOptions?.timed_pop || {}).filter(o => {
                    const okPages = (getDocFiles?.[0]?.num_pages || 0) >= (o?.show_after || 0);
                    return isLightboxSelectable(o) && okPages;
                  });
                  if (publicTimed.length === 0) {
                    return (
                      <div className="alert alert-warning my-2">
                        You don't have any TimedPop lightboxes available for this KDF. Create one in the editor first.
                        {editLaserLinkItem?.doc_id && (
                          <> <a className="ms-1" target="_blank" href={`/editor/${editLaserLinkItem?.doc_id}`}>Open Editor</a></>
                        )}
                      </div>
                    );
                  }
                  return null;
                })()}

                <Switch
                  type="checkbox"
                  checked={editLaserLinkItem?.default_flash_pop ?? false}
                  onChange={(element) => {
                    updateEditLaserLinkItem({
                      ...editLaserLinkItem,
                      default_flash_pop:
                        !!!editLaserLinkItem?.default_flash_pop,
                    });
                  }}
                  formLabel={
                    <CustomTooltip
                      title={<p className="p-1 text-light">Save settings for new LaserLINX for this KDF</p>}
                    >
                      <span>Set as default</span>
                    </CustomTooltip>
                  }
                />
                {/* <div className="d-flex align-items-center for-space"> */}
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_enter_device_Device">
                      Timed {' '}
                      {!!editLaserLinkItem?.flash_pop_settings?.lightbox && (
                        <CustomTooltip title={<p className="p-1 text-light">Preview</p>}>
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                                const popupOptionsById = Object.values(popupOptions.timed_pop).reduce((acc, item) => {
                                    acc[`${item.id}`] = item;
                                    return acc;
                                }, {});
                              setShowLightBox(
                                  popupOptionsById[
                                  editLaserLinkItem?.flash_pop_settings
                                    ?.lightbox
                                ]
                              )
                            }}
                            className="cursor-pointer"
                          />
                        </CustomTooltip>
                      )}
                    </label>
                  </Col>
                  <Col md={8}>
                    <LightboxSearchSelect
                      name="timed_pop_lightbox"
                      disabled={timedEmpty}
                      value={editLaserLinkItem?.flash_pop_settings?.lightbox ?? ""}
                      placeholder={"Select a TimedPop Lightbox"}
                      hasError={
                        editLaserLinkItem?.flash_pop === true &&
                        !editLaserLinkItem?.flash_pop_settings?.lightbox
                      }
                      onChange={(element) => {
                          const popupOptionsById = Object.values(popupOptions.timed_pop).reduce((acc, item) => {
                              acc[`${item.id}`] = item;
                              return acc;
                          }, {});
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          flash_pop_settings: {
                            ...editLaserLinkItem?.flash_pop_settings,
                            lightbox: element.target.value,
                            lightbox_name: popupOptionsById[`${element.target.value}`].name,
                            seen_seconds: popupOptionsById[`${element.target.value}`].show_after,
                            on_page: popupOptionsById[`${element.target.value}`].show_on_page,
                          },
                        })
                      }}
                      options={lightboxOptions(
                        popupOptions?.timed_pop,
                        (o) => isLightboxSelectable(o) && (getDocFiles[0]?.num_pages) >= o?.show_after
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_flash_device_Device">Device</label>
                  </Col>
                  <Col md={8}>
                    <Select
                      classList="mb-2"
                      name="timed_pop_device"
                      disabled={timedEmpty}
                      required={editLaserLinkItem?.flash_pop === true}
                      defaultValue={editLaserLinkItem?.flash_pop_settings?.display_flash_device ?? ""}
                      errorMessageStatus={
                        editLaserLinkItem?.flash_pop === true &&
                        !editLaserLinkItem?.flash_pop_settings?.display_flash_device
                      }
                      id="display_flash_device_Device"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          flash_pop_settings: {
                            ...editLaserLinkItem?.flash_pop_settings,
                            display_flash_device: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.display_device_settings")
                      )}
                    </Select>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="flash_pop_settings_after">After</label>
                  </Col>
                  <Col md={8} className="mb-2">
                    <span className="cursor-pointer">
                      <input
                        className="edit-box-input"
                        type="number"
                        value={
                          editLaserLinkItem?.flash_pop_settings?.seen_seconds ??
                          0
                        }
                        disabled={true}
                      />
                      <span className="second-text">
                        seconds on page
                      </span>
                      <input
                        className="edit-box-input"
                        type="number"
                        value={
                          editLaserLinkItem?.flash_pop_settings?.on_page ?? 0
                        }
                        disabled={true}
                      />
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="flash_pop_settings_frequency">
                      Frequency
                    </label>
                  </Col>
                  <Col md={8}>
                    <Select
                      classList="mb-2"
                       name="timed_pop_frequency"
                      required={editLaserLinkItem?.flash_pop === true}
                      defaultValue={editLaserLinkItem?.flash_pop_settings?.frequency ?? ""}
                      errorMessageStatus={
                        editLaserLinkItem?.flash_pop === true &&
                        !editLaserLinkItem?.flash_pop_settings?.frequency
                      }
                      id="flash_pop_settings_frequency"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          flash_pop_settings: {
                            ...editLaserLinkItem?.flash_pop_settings,
                            frequency: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.enter_frequency_settings")
                      )}
                    </Select>
                  </Col>
                </Row>
                {/* </div> */}
              </Col>
            ) : (
              <p>
                Select a TimedPop to appear after recipients spend a certain
                amount of time viewing the KDF with this LaserLINK.
              </p>
            )}
          </>
        </Row>
      </div>

      <div className="Enable-select">
        <Row className="enable-first">
          <>
            <Switch
              type="checkbox"
              checked={editLaserLinkItem?.exit_pop ?? false}
              onChange={(element) => {
                updateEditLaserLinkItem({
                  ...editLaserLinkItem,
                  exit_pop: !!!editLaserLinkItem?.exit_pop,
                });
              }}
              formLabel={"Enable ExitPop"}
            />
          </>
          <>
            {editLaserLinkItem?.exit_pop == true ? (
              <Col md={12} className="popup-option-coloum">
                {(() => {
                  const publicExit = Object.values(popupOptions?.exit_pop || {}).filter(isLightboxSelectable);
                  if (publicExit.length === 0) {
                    return (
                      <div className="alert alert-warning my-2">
                        You don't have any ExitPop lightboxes yet. Create a lightbox in the editor first.
                        {editLaserLinkItem?.doc_id && (
                          <> <a className="ms-1" target="_blank" href={`/editor/${editLaserLinkItem?.doc_id}`}>Open Editor</a></>
                        )}
                      </div>
                    );
                  }
                  return null;
                })()}

                <Switch
                  type="checkbox"
                  checked={editLaserLinkItem?.default_exit_pop ?? false}
                  onChange={(element) => {
                    updateEditLaserLinkItem({
                      ...editLaserLinkItem,
                      default_exit_pop: !!!editLaserLinkItem?.default_exit_pop,
                    });
                  }}
                  formLabel={
                    <CustomTooltip
                      title={<p className="p-1 text-light">Save settings for new LaserLINX for this KDF</p>}
                    >
                      <span>Set as default</span>
                    </CustomTooltip>
                  }
                />
                {/* <div className="d-flex align-items-center for-space"> */}
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_enter_device_Device">
                      On exit intent {' '}
                      {!!editLaserLinkItem?.exit_pop_settings?.lightbox && (
                        <CustomTooltip title={<p className="p-1 text-light">Preview</p>}>
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                                const popupOptionsById = Object.values(popupOptions.exit_pop).reduce((acc, item) => {
                                    acc[`${item.id}`] = item;
                                    return acc;
                                }, {});
                              setShowLightBox(
                                  popupOptionsById[
                                  editLaserLinkItem?.exit_pop_settings?.lightbox
                                ]
                              )
                            }}
                            className="cursor-pointer"
                          />
                        </CustomTooltip>
                      )}
                    </label>
                  </Col>
                  <Col md={8}>
                    <LightboxSearchSelect
                      name="exit_pop_lightbox"
                      disabled={exitEmpty}
                        value={editLaserLinkItem?.exit_pop_settings?.lightbox ?? ""}
                        placeholder={"Select an ExitPop Lightbox"}
                        hasError={
                          editLaserLinkItem?.exit_pop === true &&
                          !editLaserLinkItem?.exit_pop_settings?.lightbox
                        }
                      onChange={(element) =>{
                          const popupOptionsById = Object.values(popupOptions.exit_pop).reduce((acc, item) => {
                              acc[`${item.id}`] = item;
                              return acc;
                          }, {});
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          exit_pop_settings: {
                            ...editLaserLinkItem?.exit_pop_settings,
                            lightbox: element.target.value,
                            lightbox_name:
                            popupOptionsById[`${element.target.value}`]
                                .name,
                          },
                        })
                      }}
                      options={lightboxOptions(popupOptions?.exit_pop)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label htmlFor="display_exit_device_Device">Device</label>
                  </Col>
                  <Col md={8}>
                    <Select
                      classList="mb-2"
                      name="exit_pop_device"
                      disabled={exitEmpty}
                      required={editLaserLinkItem?.exit_pop === true}
                      defaultValue={editLaserLinkItem?.exit_pop_settings?.display_device ?? ""}
                      errorMessageStatus={
                        editLaserLinkItem?.exit_pop === true &&
                        !editLaserLinkItem?.exit_pop_settings?.display_device
                      }
                      id="display_exit_device_Device"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          exit_pop_settings: {
                            ...editLaserLinkItem?.exit_pop_settings,
                            display_device: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.display_device_settings")
                      )}
                    </Select>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <label htmlFor="exit_pop_settings_scroll">
                      On scroll up
                    </label>
                  </Col>
                  <Col md={8}>
                    <Select
                      classList="mb-2"
                      disabled={exitEmpty}
                      defaultValue={
                        editLaserLinkItem?.exit_pop_settings?.display_scroll ??
                        ""
                      }
                        errorMessageStatus={
                          editLaserLinkItem?.exit_pop === true &&
                          !editLaserLinkItem?.exit_pop_settings?.display_scroll
                        }
                      id="exit_pop_settings_scroll"
                      onChange={(element) =>
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          exit_pop_settings: {
                            ...editLaserLinkItem?.exit_pop_settings,
                            display_scroll: element.target.value,
                          },
                        })
                      }
                    >
                      {renderOption(
                        getTranslation("devise.display_scroll_settings")
                      )}
                    </Select>
                  </Col>
                </Row>
                {/* </div> */}
              </Col>
            ) : (
              <p>
                Choose an Exit Pop to appear when a recipient signals exit
                intent while viewing the KDF with this LaserLINK.
              </p>
            )}
          </>
        </Row>
      </div>
    </>
  );
};
export default PopupOptionsTab;
